import projectReducer from "src/redux/slices/project";
import { configureStore } from "@reduxjs/toolkit";
import mbRowsReducer from "src/redux/slices/MBRows";

export const store = configureStore({
  reducer: { projects: projectReducer, mbRows: mbRowsReducer },
});
